// 현금성자산 잔액 이력 API (tb_balance_history)
import axiosInstance from './axiosInstance';

// 목록 조회 (필터: account_name, ticker)
export const fetchBalanceHistory = async (params = {}) => {
  const res = await axiosInstance.get('/balance-history', { params });
  return res.data;
};

// 등록 (UPSERT: 동일 account_name+ticker+balance_date 존재 시 UPDATE)
export const createBalanceHistory = async (payload) => {
  const res = await axiosInstance.post('/balance-history', payload);
  return res.data;
};

// 수정
export const updateBalanceHistory = async (id, payload) => {
  const res = await axiosInstance.put(`/balance-history/${id}`, payload);
  return res.data;
};

// 삭제
export const deleteBalanceHistory = async (id) => {
  const res = await axiosInstance.delete(`/balance-history/${id}`);
  return res.data;
};

// 기준일자 이하 최신 잔액 1건
// params: { account_name, ticker, base_date? }
export const fetchLatestBalance = async (params) => {
  const res = await axiosInstance.get('/balance-history/latest', { params });
  return res.data;
};
